import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import store, { persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import ErrorBoundary from "./component/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));

const onBeforeLift = () => {
  try {
    const persistedState = localStorage.getItem('persist:root');
    if (persistedState) {
      JSON.parse(persistedState);
    }
  } catch (error) {
    console.error("Corrupted persisted state detected, clearing storage:", error);
    localStorage.clear();
    window.location.reload();
  }
};

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <PersistGate 
        loading={null} 
        persistor={persistor}
        onBeforeLift={onBeforeLift}
      >
        <ToastContainer />
        <App />
      </PersistGate>
    </Provider>
  </ErrorBoundary>
);
reportWebVitals();
